import axios, { AxiosPromise } from "axios"

import { PaymentStatus } from "@/shared/enums/PaymentStatus"
import { SubscriptionStatus } from '@/shared/enums/SubscriptionStatus'
import CheckoutBankTransferBank from "../../models/CheckoutBankTransferBank"
import { JSON } from "../../utils/types"

class CheckoutApi {
  private axiosInstance = axios.create({
    baseURL: `${process.env.VUE_APP_CHECKOUT_API}/ck`,
  });

  post(payload: JSON): AxiosPromise<JSON> {
    return this.axiosInstance.post("/process", payload)
  }

  transactionStatus(id: string): AxiosPromise<{ transaction_status: PaymentStatus }> {
    return this.axiosInstance.get("/status?paymentId=" + id)
  }

  subscriptionStatus(id: string): AxiosPromise<{ subscription_status: SubscriptionStatus }> {
    return this.axiosInstance.get("/subscription/status?subscriptionId=" + id)
  }

  bankTransferList(contractId: string, country: string): AxiosPromise<CheckoutBankTransferBank[]> {
    return this.axiosInstance.get("/payment/bankTransfer/list?contractId=" + contractId + "&country=" + country)
  }

  getMethods(checkoutId: string): AxiosPromise<JSON> {
    return this.axiosInstance.get(`/${checkoutId}/methods`)
  }
}

export default new CheckoutApi()
